import * as React from 'react';
import { MosaicKey } from 'react-mosaic-component/lib/types';

import { MosaicCollapsedById } from 'src/components/mosaic/types';

type MosaicContextValue = {
  collapsedById: MosaicCollapsedById<MosaicKey>;
  restoreInitialSplit: () => void;
};

export const MosaicViewContext = React.createContext<
  MosaicContextValue | undefined
>(undefined);

export const useMosaicView = () => {
  return React.useContext(MosaicViewContext);
};
